import { useLayoutEffect, useRef, useState } from 'react'

const tabListOf = (frame: HTMLElement | null) => frame?.querySelector<HTMLElement>('[data-baseweb="tab-list"]')

const usePulseTabsOverflow = (enabled: boolean, tabCount: number) => {
  const frameRef = useRef<HTMLDivElement>(null)
  const [overflowing, setOverflowing] = useState(false)

  useLayoutEffect(() => {
    const frame = frameRef.current
    const list = tabListOf(frame)
    if (!enabled || !list) {
      setOverflowing(false)
      return undefined
    }

    const measure = () => setOverflowing(list.scrollWidth > list.clientWidth + 1)
    measure()

    if (typeof ResizeObserver === 'undefined') return undefined
    const observer = new ResizeObserver(measure)
    observer.observe(list)
    if (frame) observer.observe(frame)
    return () => observer.disconnect()
  }, [enabled, tabCount])

  return { frameRef, overflowing }
}

export default usePulseTabsOverflow
